export default {
  tagged: '2.1.1-4e8d832',
  version: '2.1.1',
  revision: '4e8d832'
};